(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      /*
        Measure synchronously BEFORE the first possible scroll event.

        Previously headerBounds started as {}, and only an asynchronous
        IntersectionObserver filled it later. On heavier product pages the user
        could begin scrolling before that callback ran, so headerBounds.bottom
        was undefined and the sticky-header logic temporarily did nothing.
      */
      this.headerBounds = this.measureHeaderBounds();

      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onHeaderMediaChange = () => {
        this.setHeaderHeight();
        this.headerBounds = this.measureHeaderBounds();
      };
      this.headerMediaQuery.addEventListener('change', this.onHeaderMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      {
        const initialRawScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const initialViewportHeight = window.visualViewport
          ? window.visualViewport.height
          : (window.innerHeight || document.documentElement.clientHeight || 0);
        const initialMaxScrollTop = Math.max(
          0,
          Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0) - initialViewportHeight
        );
        this.currentScrollTop = Math.min(initialMaxScrollTop, Math.max(0, initialRawScrollTop));
      }
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.onTopStateRefresh = () => {
        const rawScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const scrollTop = Math.max(0, rawScrollTop);
        this.syncAnnouncementZone(scrollTop);
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('pageshow', this.onTopStateRefresh, false);
      window.addEventListener('resize', this.onTopStateRefresh, false);

      if ('onscrollend' in window) {
        window.addEventListener('scrollend', this.onTopStateRefresh, false);
      } else {
        this.onTouchEndTopRefresh = () => {
          window.requestAnimationFrame(this.onTopStateRefresh);
        };
        window.addEventListener('touchend', this.onTouchEndTopRefresh, { passive: true });
      }

      /*
        Keep Dawn's observer as a secondary refinement, but sticky behavior no
        longer depends on waiting for it.
      */
      this.createObserver();

      window.requestAnimationFrame(() => {
        this.setHeaderHeight();
        this.headerBounds = this.measureHeaderBounds();
        this.onTopStateRefresh();
      });
    }

    measureHeaderBounds() {
      if (!this.header) return { top: 0, bottom: 0 };

      const rect = this.header.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      return {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop,
      };
    }

    measureAnnouncementBottom() {
      const announcement = document.querySelector('.announcement-bar-section');
      if (!announcement) return 0;

      const rect = announcement.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      return Math.max(0, rect.bottom + scrollTop);
    }

    syncAnnouncementZone(scrollTop) {
      if (!this.header) return false;

      const isMobileViewport = window.matchMedia('(max-width: 989px)').matches;
      if (!isMobileViewport) {
        this.header.classList.remove('novi-announcement-zone');
        return false;
      }

      /*
        The PDP can finish image/layout work after the header connected, so the
        original headerBounds.top can become stale. Measure the announcement
        itself instead. When the page is anywhere in the announcement/header
        top zone, force the header back into normal flow immediately.
      */
      const announcementBottom = this.measureAnnouncementBottom();
      const threshold = Math.max(announcementBottom, 1) + 2;
      const inAnnouncementZone = scrollTop <= threshold;

      this.header.classList.toggle('novi-announcement-zone', inAnnouncementZone);

      if (inAnnouncementZone) {
        this.reset();
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate',
          'scrolled-past-header'
        );
      }

      return inAnnouncementZone;
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onTopStateRefresh);
      window.removeEventListener('resize', this.onTopStateRefresh);

      if ('onscrollend' in window) {
        window.removeEventListener('scrollend', this.onTopStateRefresh);
      } else if (this.onTouchEndTopRefresh) {
        window.removeEventListener('touchend', this.onTouchEndTopRefresh);
      }

      if (this.headerMediaQuery && this.onHeaderMediaChange) {
        this.headerMediaQuery.removeEventListener('change', this.onHeaderMediaChange);
      }
    }

    createObserver() {
      if (!this.header) return;

      let observer = new IntersectionObserver((entries, observer) => {
        /*
          Use document-space measurements rather than relying on intersectionRect
          alone. This remains stable even if the product page is still laying out
          large images when the observer callback arrives.
        */
        this.headerBounds = this.measureHeaderBounds();
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      /*
        iOS can report temporary negative / beyond-the-document scroll offsets
        during elastic overscroll. Clamp those values so a fast bounce at the
        top or bottom cannot make the sticky header falsely think the shopper
        reversed direction.
      */
      const rawScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const viewportHeight = window.visualViewport
        ? window.visualViewport.height
        : (window.innerHeight || document.documentElement.clientHeight || 0);
      const maxScrollTop = Math.max(
        0,
        Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0) - viewportHeight
      );
      const scrollTop = Math.min(maxScrollTop, Math.max(0, rawScrollTop));

      /*
        Hard top-of-page guard. On the PDP, late image/layout changes can make
        the cached header bounds stale. The announcement bar itself is the
        source of truth, so if it should be visible we reset immediately before
        any hide/reveal direction logic runs.
      */
      if (this.syncAnnouncementZone(scrollTop)) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /*
        While the mobile drawer is open its own code controls the header's
        viewport position. Do not let normal sticky-scroll logic fight it.
      */
      if (document.documentElement.classList.contains('novi-mobile-menu-open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (
        !this.headerBounds ||
        !Number.isFinite(this.headerBounds.top) ||
        !Number.isFinite(this.headerBounds.bottom)
      ) {
        this.headerBounds = this.measureHeaderBounds();
      }

      const isMobileViewport = window.matchMedia('(max-width: 989px)').matches;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;

        /*
          On mobile apply the hidden state immediately. Delaying it by one
          animation frame during momentum scrolling lets the browser render an
          intermediate sticky position.
        */
        if (isMobileViewport) {
          this.hide();
        } else {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          /*
            Upward mobile scrolling is the case that was exposing the gap.
            Reveal synchronously and with no `animate` class.
          */
          if (isMobileViewport) {
            this.reveal();
          } else {
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          if (isMobileViewport) {
            this.hide();
          } else {
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');

        /*
          Reset immediately as the announcement bar comes back into view. This
          returns the header to normal document flow directly underneath it,
          instead of letting a fixed/sticky header overlap the bar for a frame.
        */
        if (isMobileViewport) {
          this.reset();
        } else {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      if (window.matchMedia('(max-width: 989px)').matches) {
        this.header.classList.remove('animate');
      }

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      if (window.matchMedia('(max-width: 989px)').matches) {
        /*
          Mobile reveal is intentionally instantaneous. The Dawn `animate`
          class transitions the sticky header's vertical position and is what
          can expose a temporary strip above it during a fast upward swipe.
        */
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        return;
      }

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
